import createSagaMiddleware from 'redux-saga';
import combineSectionReducers from 'combine-section-reducers';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import {
  gesamtbeitragMitRabattReducer,
  gesamtbeitragReducerForApp,
  jahresbeitragReducer,
  rabattstufeReducer,
} from '@ps20-frontend/reducers';
import { App } from '@ps20-frontend/frontend-models';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';
import { IAppState } from './appState';
import { rootReducer } from './reducers/rootReducer.reducer';
import { rootSaga } from './sagas/rootSaga';
import { INITIAL_STATE } from './initialState';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { vorbelegungenReducer } from './reducers/vorbelegungen.reducer';
import { risikoortReducer } from './reducers/risikoort.reducer';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { adressvorschlagReducer } from './reducers/adressvorschlag.reducer';
import { vorschaedenReducer } from './reducers/vorschaeden.reducer';
import { thhHundVertragsoptionenReducer } from './reducers/vertragsoptionen.reducer';
import { thhHundTaasInfoReducer } from './reducers/thhHundTaasInfo.reducer';
import { thhHundProduktReducer } from './reducers/produkt.reducer';
import { antragsnummerReducer } from './reducers/antragsnummerReducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  transientState: transientStateReducer,
  vorbelegungen: vorbelegungenReducer,
  risikoort: risikoortReducer,
  versicherungsnehmer: versicherungsnehmerReducer,
  adressvorschlag: adressvorschlagReducer,
  vorschaeden: vorschaedenReducer,
  vertragsoptionen: thhHundVertragsoptionenReducer,
  produkt: thhHundProduktReducer,
  taasInfo: thhHundTaasInfoReducer,
  rabattstufe: rabattstufeReducer,
  gesamtbeitrag: gesamtbeitragReducerForApp(App.THH_HUND),
  gesamtbeitragMitRabatt: gesamtbeitragMitRabattReducer,
  jahresbeitrag: jahresbeitragReducer,
  antragsnummer: antragsnummerReducer,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.THH_HUND);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('thh-hund-angebot-gui'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
